/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState, useEffect, ReactElement, useContext } from 'react'

import {
  Row,
  Col,
  Table,
  Form,
  Input,
  Button,
  PageHeader,
  Skeleton,
  Spin,
} from 'antd'
import DateRange from 'Components/Form/DateRange'
import PesquisaVeiculo from 'Components/Form/PesquisaVeiculo'
import { SelectFieldAnt, SelectItemProps } from 'Components/Form/Select'
import ID_COMPONENTE from 'config/idComponente'
import { ApplicationContext } from 'Context'
import Veiculos from 'Helpers/Veiculos'
import { Empresa, Veiculo } from 'Models/cadastros'
import { IArmazem, IDoca } from 'Models/docas'
import IAcao from 'Models/docas/IAcao'
import IFormDocasLogsFilter from 'Models/docas/IFormDocasLogsFilter'
import ILog from 'Models/docas/ILog'
import UsuarioDocas from 'Models/docas/Usuario'
import moment from 'moment'
import { useForm } from 'react-hook-form'
import { ParamsRequest } from 'Services/__shared/types/resquest'
import WsCadastroService from 'Services/WS_CADASTRO'
import WsDocasService from 'Services/WS_DOCAS'
import IFormEmpresasFilter from 'Views/Cadastros/Empresas/IFormEmpresasFilter'
import IFormVeiculosFilter from 'Views/Cadastros/Veiculos/IFormVeiculosFilter'

import { DocasContext } from '../Context/context'

const ModalLogs = (): ReactElement => {
  const hookForm = useForm()
  const [form] = Form.useForm()
  const { docasContext, setDocasContext } = useContext(DocasContext)
  const { applicationContext } = useContext(ApplicationContext)

  const [armazens, setArmazens] = useState<IArmazem[]>([])
  const [logs, setLogs] = useState<ILog[]>([])

  const [selectAcaoItens, setSelectAcaoItens] = useState<SelectItemProps[]>([])
  const [selectArmazemItens, setSelectArmazemItens] = useState<
    SelectItemProps[]
  >([])
  const [selectDocaItens, setSelectDocaItens] = useState<SelectItemProps[]>([])
  const [selectUsuarioItens, setSelectUsuarioItens] = useState<
    SelectItemProps[]
  >([])

  const [cdArmazemSelecionado, setCdArmazemSelecionado] = useState<number>()

  const [veiculoSelecionado, setVeiculoSelecionado] = useState<Veiculo>()
  const [transportadoraSelecionada, setTransportadoraSelecionada] =
    useState<Empresa>()

  const [carregandoPesquisa, setCarregandoPesquisa] = useState<boolean>(false)
  const [carregandoExportacao, setCarregandoExportacao] =
    useState<boolean>(false)
  const [carregandoAcoes, setCarregandoAcoes] = useState<boolean>(true)
  const [carregandoArmazens, setCarregandoArmazens] = useState<boolean>(true)
  const [carregandoUsuarios, setCarregandoUsuarios] = useState<boolean>(true)

  useEffect(() => {
    getAcoes()
    getArmazens()
    getUsuarios()
  }, [])

  const getAcoes = async () => {
    const { data } = await WsDocasService.misc.getAcoes(ID_COMPONENTE.DOCAS)

    if (data.items) {
      const selectAcoesData: SelectItemProps[] = data.items.map(
        (item: IAcao) => {
          return {
            value: item.cdAcao.toString(),
            label: item.descricao,
          }
        },
      )

      setSelectAcaoItens(selectAcoesData)
    }

    setCarregandoAcoes(false)
  }

  const getArmazens = async () => {
    const { data } = await WsDocasService.armazem.getList(ID_COMPONENTE.DOCAS, {
      apenasAtivos: true,
    })

    if (data.items) {
      setArmazens(data.items)

      const selectArmazensData: SelectItemProps[] = data.items
        // .filter((f) => f.ativo)
        .map((item: IArmazem) => {
          return {
            value: item.cdAgendamentoDocasArmazem.toString(),
            label: item.nomeArmazem,
          }
        })

      setSelectArmazemItens(selectArmazensData)
    }

    setCarregandoArmazens(false)
  }

  const getUsuarios = async () => {
    const { data } = await WsDocasService.usuario.getList(ID_COMPONENTE.DOCAS)

    if (data.items) {
      const selectUsuariosData: SelectItemProps[] = data.items.map(
        (item: UsuarioDocas) => {
          return {
            value: item.cdUsuario.toString(),
            label: item.nome,
          }
        },
      )

      setSelectUsuarioItens(selectUsuariosData)
    }

    setCarregandoUsuarios(false)
  }

  const handleChangeArmazem = (cdArmazemString: string) => {
    if (cdArmazemString !== '') {
      const cdArmazem: number = parseInt(cdArmazemString)
      const armazem: IArmazem | undefined = armazens.find(
        (f) => f.cdAgendamentoDocasArmazem == cdArmazem,
      )

      if (armazem) {
        const selectDocasData: SelectItemProps[] =
          armazem.agendamentoDocasDocas.map((item: IDoca) => {
            return {
              value: item.cdAgendamentoDocasDocas.toString(),
              label: item.nomeDoca,
            }
          })

        setSelectDocaItens(selectDocasData)
        setCdArmazemSelecionado(cdArmazem)
      }
    } else {
      setCdArmazemSelecionado(undefined)
    }
  }

  const pesquisaOuExportaLogs = async (filtros: IFormDocasLogsFilter) => {
    if (filtros.intervalo) {
      filtros.dataInicio = filtros.intervalo[0].format('YYYY-MM-DD HH:mm:ss')
      filtros.dataFim = filtros.intervalo[1].format('YYYY-MM-DD HH:mm:ss')
    } else {
      const dataAtual: string = moment().format('YYYY-MM-DD')
      filtros.dataInicio = dataAtual + ' 00:00:00'
      filtros.dataFim = dataAtual + ' 23:59:59'
    }

    if (veiculoSelecionado) {
      filtros.cdVeiculos = [veiculoSelecionado.id]
    }

    if (transportadoraSelecionada) {
      filtros.cdEntidade = transportadoraSelecionada.id
    }

    if (carregandoPesquisa) {
      const { data } = await WsDocasService.log.getList(
        ID_COMPONENTE.DOCAS,
        filtros,
      )

      if (data.items) {
        setLogs(data.items)
      }

      setCarregandoPesquisa(false)
    } else {
      const { data } = await WsDocasService.log.export(
        ID_COMPONENTE.DOCAS,
        filtros,
      )

      if (data.items) {
        const a: any = document.createElement('A')
        a.href =
          'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; base64,' +
          data.items
        a.download = 'Log de ações.xlsx'
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
      }

      setCarregandoExportacao(false)
    }
  }

  return (
    <>
      <Form onFinish={pesquisaOuExportaLogs} layout="vertical" form={form}>
        <PageHeader
          ghost={false}
          title="Log de Ações"
          extra={[
            <Button
              key="pesquisaLogs"
              type="primary"
              htmlType="submit"
              loading={carregandoPesquisa}
              onClick={() => setCarregandoPesquisa(true)}
            >
              Pesquisar
            </Button>,

            <Button
              key="exportaLogs"
              type="primary"
              htmlType="submit"
              loading={carregandoExportacao}
              onClick={() => setCarregandoExportacao(true)}
            >
              Exportar
            </Button>,
          ]}
        >
          <Row gutter={16}>
            <Col span={8}>
              <DateRange
                name="intervalo"
                label="Intervalo:"
                showTime={true}
                maxDays={30}
              />
            </Col>

            <Col span={16}>
              <PesquisaVeiculo
                form={form}
                setVeiculoSelecionado={setVeiculoSelecionado}
                veiculoSelecionado={veiculoSelecionado}
                obrigatorioSelecionarTransportadora={false}
                setTransportadoraSelecionada={setTransportadoraSelecionada}
                transportadoraSelecionada={transportadoraSelecionada}
              />
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={8}>
              {carregandoUsuarios ? (
                <Form.Item label="Usuário:" name="cdUsuario">
                  <Spin />
                </Form.Item>
              ) : (
                <SelectFieldAnt
                  methods={hookForm}
                  scope="form-logs"
                  label="Usuário:"
                  name="cdUsuario"
                  items={selectUsuarioItens}
                  showSearch={true}
                  emptyValue={true}
                />
              )}
            </Col>

            <Col span={8}>
              {carregandoAcoes ? (
                <Form.Item label="Ação:" name="cdAcao">
                  <Spin />
                </Form.Item>
              ) : (
                <SelectFieldAnt
                  methods={hookForm}
                  scope="form-logs"
                  label="Ação:"
                  name="cdAcao"
                  items={selectAcaoItens}
                  showSearch={true}
                  emptyValue={true}
                />
              )}
            </Col>

            <Col span={8}>
              <Form.Item name="numeroViagem" label="Nº Viagem:">
                <Input type="number" />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={8}>
              <Form.Item
                name="numeroDocumento"
                label={`${applicationContext.textoDocumentoViagem!}:`}
              >
                <Input type="text" />
              </Form.Item>
            </Col>

            <Col span={8}>
              {carregandoArmazens ? (
                <Form.Item label="Armazém:" name="cdArmazem">
                  <Spin />
                </Form.Item>
              ) : (
                <SelectFieldAnt
                  methods={hookForm}
                  scope="form-logs"
                  label="Armazém:"
                  name="cdArmazem"
                  items={selectArmazemItens}
                  onChangeValue={handleChangeArmazem}
                  showSearch={true}
                  emptyValue={true}
                />
              )}
            </Col>

            <Col span={8}>
              <SelectFieldAnt
                methods={hookForm}
                scope="form-logs"
                label="Doca:"
                name="cdDoca"
                items={selectDocaItens}
                showSearch={true}
                emptyValue={true}
                disabled={!cdArmazemSelecionado}
              />
            </Col>
          </Row>
        </PageHeader>
      </Form>

      <Row>
        <Col span={24}>
          <Table
            size="small"
            pagination={false}
            scroll={{ y: 240 }}
            columns={[
              {
                title: 'Data/Hora',
                key: 'dtAcao',
                dataIndex: 'dtAcao',
              },
              {
                title: 'Usuário',
                key: 'usuario',
                dataIndex: 'usuario',
              },
              {
                title: 'Armazém',
                key: 'nomeArmazem',
                dataIndex: 'nomeArmazem',
              },
              {
                title: 'Doca',
                key: 'nomeDoca',
                dataIndex: 'nomeDoca',
              },
              {
                title: 'Veículo',
                key: 'placaVeiculo',
                dataIndex: 'placaVeiculo',
              },
              {
                title: 'Transportadora',
                key: 'nomeTransportadora',
                dataIndex: 'nomeTransportadora',
              },
              {
                title: 'Ação',
                key: 'acao',
                dataIndex: 'acao',
              },
              {
                title: 'Viagem',
                key: 'numeroViagem',
                dataIndex: 'numeroViagem',
              },
              {
                title: applicationContext.textoDocumentoViagem!,
                key: 'numeroDocumento',
                dataIndex: 'numeroDocumento',
              },
            ]}
            dataSource={logs}
          />
        </Col>
      </Row>
    </>
  )
}

export default ModalLogs
